import AppRoutes from "./Routes";

function App() {
  return <AppRoutes />;
}

export default App;